import {
  Box,
  Paper,
  Grid,
  Button,
  Typography,
  Divider,
} from '@mui/material';

import { useAuth } from "../context/AuthContext";

import config from "../twh/config";           
import { getFirstErrorMessage } from "../twh/functions"; 

// Import existing logos (keep only what you actually have)
import logoFacebook from '../assets/images/meta-facebook.png';
import logoGoogleReview from '../assets/images/google-review.png';
import logoGoogleAnalytics from '../assets/images/google-analytics.png';
import logoGoogleAds from '../assets/images/google-ads.png';

// Placeholder for all missing logos
import imagePlaceholder from '../assets/images/image-placeholder.png';




export default function Integrations() {

  const { userData } = useAuth();

  const userWebSettings = userData?.webSettings;

  console.log(userWebSettings);

  return (
    <Box sx={{ pb: 6 }}>
      <Typography variant="h4" fontWeight={800} gutterBottom>
        INTEGRATIONS
      </Typography>

      {/* ── SOCIAL ──────────────────────────────────────────────── */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          bgcolor: 'white',
          p: 3,
          mb: 4,
        }}
      >
        <Typography variant="h6" fontWeight={800} sx={{ mb: 2, color: '#FF2C6D' }}>
          SOCIAL
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {/* Instagram */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Instagram" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Instagram
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* TikTok */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="TikTok" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              TikTok
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Facebook */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={logoFacebook} alt="Facebook" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Facebook
            </Typography>
          </Grid>

          
        {(userWebSettings?.facebook_meta_ad_account_id == null || userWebSettings?.facebook_meta_ad_account_id == "") ? (

          <Button
            href={config.reactApi_baseUrl + '/react-api/integrations/facebook-meta-auth.php'}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>

        ) : (

          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#FFC03A',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#FF3F78' },
            }}
          >
            Disconnect
          </Button>

        )}


        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Tripadvisor */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Tripadvisor" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Tripadvisor
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
      </Paper>

      {/* ── MARKETING ───────────────────────────────────────────── */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          bgcolor: 'white',
          p: 3,
          mb: 4,
        }}
      >
        <Typography variant="h6" fontWeight={800} sx={{ mb: 2, color: '#FF2C6D' }}>
          MARKETING
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {/* Google My Business */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={logoGoogleReview} alt="Google My Business" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Google My Business
            </Typography>
          </Grid>

          
        {(userWebSettings.google_my_business_location_id == null || userWebSettings.google_my_business_location_id == "") ? (

          <Button
            href={config.reactApi_baseUrl + '/react-api/integrations/google-my-business-auth.php'}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>

        ) : (

          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#FFC03A',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#FF3F78' },
            }}
          >
            Disconnect
          </Button>

          
        )}

        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Analytics */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={logoGoogleAnalytics} alt="Google Analytics" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Analytics
            </Typography>
          </Grid>

        {(userWebSettings?.google_analytics_property_id == null || userWebSettings?.google_analytics_property_id == "") ? (

          <Button
            href={config.reactApi_baseUrl + '/react-api/integrations/google-analytics-auth.php'}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>

        ) : (

          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#FFC03A',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#FF3F78' },
            }}
          >
            Disconnect
          </Button>

        )}

        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Google Ads */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={logoGoogleAds} alt="Google Ads" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Google Ads
            </Typography>
          </Grid>
        
        
        {(userWebSettings?.google_ads_customer_id == null || userWebSettings?.google_ads_customer_id == "") ? (

          <Button
            href={config.reactApi_baseUrl + '/react-api/integrations/google-ads-auth.php'}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>

        ) : (

          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#FFC03A',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#FF3F78' },
            }}
          >
            Disconnect
          </Button>

        )}
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Looker data */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Looker" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Looker Studio
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Social pilot */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="SocialPilot" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              SocialPilot
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Mailchimp */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Mailchimp" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Mailchimp
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
      </Paper>

      {/* ── PERSONNEL PLANNING ──────────────────────────────────── */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          bgcolor: 'white',
          p: 3,
          mb: 4,
        }}
      >
        <Typography variant="h6" fontWeight={800} sx={{ mb: 2, color: '#FF2C6D' }}>
          PERSONNEL PLANNING
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {/* Eitje */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Eitje" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Eitje
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Horeko */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Horeko" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Horeko
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
      </Paper>

      {/* ── LOYALTY ─────────────────────────────────────────────── */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          bgcolor: 'white',
          p: 3,
          mb: 4,
        }}
      >
        <Typography variant="h6" fontWeight={800} sx={{ mb: 2, color: '#FF2C6D' }}>
          LOYALTY
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {/* Piggy */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Piggy" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Piggy
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
      </Paper>

      {/* ── RESERVATIONS ────────────────────────────────────────── */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          bgcolor: 'white',
          p: 3,
          mb: 4,
        }}
      >
        <Typography variant="h6" fontWeight={800} sx={{ mb: 2, color: '#FF2C6D' }}>
          RESERVATIONS
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {/* Zenchef */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Zenchef" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Zenchef
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Quandoo */}
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="Quandoo" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              Quandoo
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* The Fork */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="TheFork" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              The Fork
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
      </Paper>

      {/* ── EVENTS ──────────────────────────────────────────────── */}
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          bgcolor: 'white',
          p: 3,
        }}
      >
        <Typography variant="h6" fontWeight={800} sx={{ mb: 2, color: '#FF2C6D' }}>
          EVENTS
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {/* MICE */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid display="flex" alignItems="center" gap={2}>
            <img src={imagePlaceholder} alt="MICE" width={50} height={50} style={{ objectFit: 'contain' }} />
            <Typography variant="body1" fontWeight={500}>
              MICE
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: '#0b1fae',
              textTransform: 'uppercase',
              fontSize: 12,
              px: 3,
              py: 1,
              '&:hover': { backgroundColor: '#091a91' },
            }}
          >
            Connect
          </Button>
        </Grid>
      </Paper>
    </Box>
  );
}